import * as constantes from '../../constantes';
import React, { Component } from 'react';
import { Container, Header, Message } from 'semantic-ui-react';
import { useParams } from 'react-router-dom';
import { Inicio , Form1 , Filtro2 , Filtro3 , Aceptado, Rechazado } from './wizard.js';
import { estados } from './Estados.js';
import { MaquinaDeEstados } from './MaquinaDeEstados.js';

import auth0Client from '../Auth/Auth'; 
const server = constantes.REST_API_PRIVATE;

const WrappedAnalisis = props => {
  const params = useParams();
  return <Analisis idAnalisis={params.id} />
}

class Analisis extends Component {

    constructor(props) {
        super(props);
        this.state = {
          casoIdAnalisis : props.idAnalisis,
          currentState: estados.INICIADO,
          vehicleType: null,
          vehicles: [],
          resultado:'',
          mensaje:'',
          casoActivo: null,
          isLoaded: false,
          error:'',
          wsError : null 
        };
        this._next = this._next.bind(this);
        this._back = this._back.bind(this);
        this._saveForm01 = this._saveForm01.bind(this);
        this._saveForm02 = this._saveForm02.bind(this);
        this._saveForm03 = this._saveForm03.bind(this);
        this.maquinaDeEstados = new MaquinaDeEstados();
      }

      componentDidMount() {
        
        auth0Client.isExpired();

        if( this.state.casoIdAnalisis ){
          this.cargarCasoPorId( this.state.casoIdAnalisis );
        }/*else{
          this.cargarCasoActivoDeUsuario();
        }*/
        
      }

      componentDidUpdate(){
        let METHODNAME = 'componentDidUpdate - ';
        console.log(METHODNAME + 'INI');

        auth0Client.isExpired();

        if( this.state.currentState === estados.INICIADO ){
          console.log(METHODNAME + 'Mostrar pantalla inicial, aqui volver a cargar el caso nuevo');
        } 

        console.log(METHODNAME + 'FIN');
      }

    /*
    async cargarCasoActivoDeUsuario(){
      let METHODNAME = 'cargarCasoActivoDeUsuario - ';
      console.log(METHODNAME + 'INI');
      
      let idUsuario = 1 ;
      
      let url = server+`/caso/usuario/${idUsuario}/`;

      console.log(METHODNAME + `Traer el Caso Activo para el usuario ${idUsuario}`);

      fetch( 
          url , {
          method: 'GET',
          headers:{
              'Accept':'application/json',
              'Content-Type':'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
          }
      })
      .then(res => res.json())
      .then(
          (result) => {

            console.log(METHODNAME + 'casoId = ' + result.caso.casoId );

            this.setState({
                isLoaded: true,
                casoActivo : result.caso 
            });

            console.log(METHODNAME + 'state . casoId = ' + this.state.casoActivo.casoId );

          },
          (error) => {
            console.log(METHODNAME + 'error = ' + error );
            console.log(METHODNAME + 'error = ' + error.message );
            this.setState({
                isLoaded: true,
                error : error.message ,
                wsError : error 
            });
          }
      );

      console.log(METHODNAME + 'FIN');
    }
    */

    async cargarCasoPorId( idCasoAnalisis ){
      let METHODNAME = 'cargarCasoPorId - ';
      console.log(METHODNAME + 'INI');
      
      let url = server+`/caso/${idCasoAnalisis}/`;

      fetch( 
          url , {
          method: 'GET',
          headers:{
              'Accept':'application/json',
              'Content-Type':'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
          }
      })
      .then(res => res.json())
      .then(
          (result) => {

            console.log(METHODNAME + 'casoId = ' + result.caso.casoId );

            this.setState({
                isLoaded: true,
                casoActivo : result.caso 
            });

            console.log(METHODNAME + 'state . casoId = ' + this.state.casoActivo.casoId );

          },
          (error) => {
            console.log(METHODNAME + 'error = ' + error );
            console.log(METHODNAME + 'error = ' + error.message );
            this.setState({
                isLoaded: true,
                error : error.message ,
                wsError : error 
            });
          }
      );
     
      console.log(METHODNAME + 'FIN');
    }
    
      _saveForm01( miForm ) {
        let METHODNAME = '_saveForm01 - ';
        console.log(METHODNAME + 'INI');
        console.log(METHODNAME + 'FIN');
      }

      _saveForm02( miForm ) {
        let METHODNAME = '_saveForm02 - ';
        console.log(METHODNAME + 'INI');
        console.log(METHODNAME + 'FIN');
      }

      _saveForm03( miForm ) {
        let METHODNAME = '_saveForm03 - ';
        console.log(METHODNAME + 'INI');
        console.log(METHODNAME + 'FIN');
      }
    
      _next(desiredState) {
        let currentState = this.state.currentState;
        let nextState = this.maquinaDeEstados.transitionTo(currentState, desiredState);
        this.setState({
          currentState: nextState
        });
      }
    
      _back(desiredState) {
        let currentState = this.state.currentState;
        this.setState({
          currentState: this.maquinaDeEstados.transitionFrom(currentState, desiredState)
        });
      }

  
  /*
   * Just a note -- you'll see the _next and _back functions
   * get passed around to child components alot. This is not
   * a very good practice, and in the real-world it would be
   * better to use a library like redux to handle application
   * state.
   */
  _currentStep() {

    switch(this.state.currentState) {
      case estados.INICIADO:
        return(<Inicio next={this._next} caso={this.state.casoActivo} />);
      case estados.FASE_1:
        return(<Form1
          saveForm={this._saveForm01}
          back={this._back}
          next={this._next}
          caso={this.state.casoActivo} />);
      case estados.FASE_2:
        return(<Filtro2 
          saveForm={this._saveForm02}
          back={this._back}
          next={this._next}
          caso={this.state.casoActivo} />);
      case estados.FASE_3:
        return(<Filtro3 
          saveForm={this._saveForm03}
          back={this._back}
          next={this._next}
          caso={this.state.casoActivo} />); 
      case estados.ACEPTADO:
        return(<Aceptado
            resultado={this.state.resultado}
            mensaje={this.state.mensaje}
            back={this._back}
            next={this._next}
            caso={this.state.casoActivo} />);
      case estados.RECHAZADO:
        return(<Rechazado
            resultado={this.state.resultado}
            mensaje={this.state.mensaje}
            back={this._back}
            next={this._next}
            caso={this.state.casoActivo} />);
      default:
        return(<Inicio next={this._next} 
                      caso={this.state.casoActivo} />);
    }
  }

  render() {

    const {isLoaded , error , wsError } = this.state;

    if (!isLoaded) {
      return <div>Loading...</div>;
    } else {

        if( this.state.wsError != null ){
          return (
        
           <div>
             
              <Message 
                  color='red'
                  icon='times'
                  header='ERROR:'
                  content={wsError.message}/>

              <Message 
                  color='red'
                  icon='times'
                  header='ERROR:'
                  content={'Detalle del Error : '+wsError.stack} /> 
               
           </div>
          
        );
        }else{
          return (
        
            <Container text>
  
              <Header as='h1' textAlign='center' className='h2'>ANÁLISIS DE EXPEDIENTE</Header>

              <p>
                {this._currentStep()}
              </p>

            </Container>
          
        );
        }
      
    }
  }
}

export default WrappedAnalisis;